import { pick } from 'lodash';

const usersEndpoint = '/api/users';
const userEndpoint = id => `${ usersEndpoint }/${ id }`;

export default [ 'api', function(api) {
  return {
    findAll: (page = undefined, perpage = undefined) => {
      return api.get(usersEndpoint+(page ? '?page='+(page)+ (page > -1 ? '&perpage='+(perpage || '20') : '') : '')).
        then(response => response.data);
    },
    find: id => {
      return api.get(userEndpoint(id))
        .then(response => response.data);
    },
    save: user => {
      return api.upload(userEndpoint(user.id), user)
        .then(response => response.data);
    },
    search: (type, text, page = null) => {
      return api.get(`${usersEndpoint}?type=${type}&text=${text}`+(page ? '&page='+page : '')).then(response => response.data);
    }
  };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/services/users.service.js